import { Outlet, useLocation } from "react-router-dom";
import { GraduationCapIcon } from "lucide-react";

function Layout() {
  const location = useLocation();

  const hideHeader = location.pathname === "/";

  return (
    <div className="min-h-screen bg-background">
      {!hideHeader && (
        <header className="bg-[#1a3a5c] px-8 py-3">
          <div className="flex items-center max-w-[1400px] mx-auto">
            <div className="flex items-center gap-3">
              <GraduationCapIcon className="size-6 text-white" />
              <span className="text-xl font-bold tracking-tight">
                <span className="text-white">High </span>
                <span className="text-[#E4BA07] italic">Impact </span>
                <span className="text-white">Class</span>
              </span>
            </div>
          </div>
        </header>
      )}

      <main className="px-8 py-6">
        <div className="max-w-[1400px] mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default Layout;
